export const scrollToSection = function (section: string) {
  document.querySelector(`${section}`)?.scrollIntoView({
    behavior: "smooth",
    block: "start",
  });
};
export const setScrolling = function (type: "none" | "auto") {
  if (type === "auto") {
    document.body.style.overflow = "auto";
    // for iphone
    document.body.style.touchAction = "auto";
  } else {
    document.body.style.overflow = "hidden";
    // for iphone
    document.body.style.touchAction = "none";
  }
};
